import gqlApi from '../../api/gql'

// initial state
const state = () => ({
  productCategories: [],
  productCategoriesUiMeta: [],
  productCategory: {},

  products: [],
  productsUiMeta: [],
  product: {},

  productShippings: [],
  productShippingsUiMeta: [],
  productShipping: {},

  productCoupons: [],
  productCouponsUiMeta: [],
  productCoupon: {},

  productOrders: [],
  productOrdersUiMeta: [],
  productOrder: {},

  productOrderItemsUiMeta: [],
})

// getters
const getters = {}

// actions
const actions = {
  listProductCategories({ commit, state }) {
    return gqlApi.query({
      query: `
        query($name: String!){
          GetUiMeta(name: $name, filterInvisible: true){
            key
            label
          }
          ListProductCategories{
            invisible_id
            name
            image_url
            sequence
            i18n_status
            created_at
            updated_at
          }
        }
      `,
      variables: {
        name: 'ProductCategoryListVo',
      }
    }).then(data => {
      commit('set', ['productCategoriesUiMeta', data.GetUiMeta])
      commit('setProductCategories', data.ListProductCategories)
      return true
    })
  },
  getProductCategory({ commit, state }, id) {
    return gqlApi.query({
      query: `
        query($id: String!){
          GetProductCategory(id: $id){
            created_at
            description
            id
            image_url
            name
            parent_id
            sequence
            status
            updated_at
          }
        }
      `,
      variables: {
        id,
      },
    }).then(resp => {
      commit('setProductCategory', resp.GetProductCategory)
      return true
    })
  },
  updateProductCategory(_, productCategory) {
    return gqlApi.query({
      query: `    
        mutation($input: ProductCategoryUpdateVo){
          UpdateProductCategory(input: $input){
            id
          }
        }
      `,
      variables: {
        input: productCategory,
      },
    }).then(() => {
      return true
    })
  },
  addProductCategory(_, productCategory) {
    return gqlApi.query({
      query: `    
        mutation($input: ProductCategoryAddVo){
          AddProductCategory(input: $input){
            id
          }
        }
      `,
      variables: {
        input: productCategory,
      },
    }).then(() => {
      return true
    })
  },
  deleteProductCategory(_, id) {
    return gqlApi.query({
      query: `    
        mutation($id: String){
          DeleteProductCategory(id: $id)
        }
      `,
      variables: {  
        id: id,
      },
    }).then(() => {
      return true
    })
  },

  listProducts({ commit, state }) {
    return gqlApi.query({
      query: `
        query($name: String!){
          GetUiMeta(name: $name, filterInvisible: true){
            key
            label
          }
          ListProducts{
            created_at
            invisible_id
            name
            i18n_status
            sequence
            image_url
            updated_at
          }
        }
      `,
      variables: {
        name: 'ProductListVo',
      }
    }).then(data => {
      commit('set', ['productsUiMeta', data.GetUiMeta])
      commit('setProducts', data.ListProducts)
      return true
    })
  },
  getProduct({ commit, state }, id) {
    return gqlApi.query({
      query: `
        query($id: String!){
          GetProduct(id: $id){
            category_id
            created_at
            desc_html
            desc_style
            id
            image_urls
            name
            price
            status
            sequence
            spec
            updated_at
          }
        }
      `,
      variables: {
        id,
      },
    }).then(resp => {
      commit('setProduct', resp.GetProduct)
      return true
    })
  },
  updateProduct(_, product) {
    return gqlApi.query({
      query: `    
        mutation($input: ProductUpdateVo){
          UpdateProduct(input: $input){
            id
          }
        }
      `,
      variables: {
        input: product,
      },
    }).then(() => {
      return true
    })
  },
  addProduct(_, product) {
    return gqlApi.query({
      query: `    
        mutation($input: ProductAddVo){
          AddProduct(input: $input){
            id
          }
        }
      `,
      variables: {
        input: product,
      },
    }).then(() => {
      return true
    })
  },
  deleteProduct(_, id) {
    return gqlApi.query({
      query: `    
        mutation($id: String){
          DeleteProduct(id: $id)
        }
      `,
      variables: {  
        id: id,
      },
    }).then(() => {
      return true
    })
  },

  listProductShippings({ commit, state }) {
    return gqlApi.query({
      query: `
        query($name: String!){
          GetUiMeta(name: $name, filterInvisible: true){
            key
            label
          }
          ListProductShippings{
            created_at
            invisible_id
            name
            created_at
            description
            invisible_id
            name
            updated_at
            updated_at
          }
        }
      `,
      variables: {
        name: 'ProductShippingListVo',
      }
    }).then(data => {
      commit('set', ['productShippingsUiMeta', data.GetUiMeta])
      commit('setProductShippings', data.ListProductShippings)
      return true
    })
  },
  getProductShipping({ commit, state }, id) {
    return gqlApi.query({
      query: `
        query($id: String!){
          GetProductShipping(id: $id){
            created_at
            deliver_area
            description
            id
            name
            shipping_fee_rule
            updated_at
          }
        }
      `,
      variables: {
        id,
      },
    }).then(resp => {
      commit('setProductShipping', resp.GetProductShipping)
      return true
    })
  },
  updateProductShipping(_, productShipping) {
    return gqlApi.query({
      query: `    
        mutation($input: ProductShippingUpdateVo){
          UpdateProductShipping(input: $input){
            id
          }
        }
      `,
      variables: {
        input: productShipping,
      },
    }).then(() => {
      return true
    })
  },
  addProductShipping(_, productShipping) {
    return gqlApi.query({
      query: `    
        mutation($input: ProductShippingAddVo){
          AddProductShipping(input: $input){
            id
          }
        }
      `,
      variables: {
        input: productShipping,
      },
    }).then(() => {
      return true
    })
  },
  deleteProductShipping(_, id) {
    return gqlApi.query({
      query: `    
        mutation($id: String){
          DeleteProductShipping(id: $id)
        }
      `,
      variables: {  
        id: id,
      },
    }).then(() => {
      return true
    })
  },

  listProductCoupons({ commit, state }) {
    return gqlApi.query({
      query: `
        query($name: String!){
          GetUiMeta(name: $name, filterInvisible: true){
            key
            label
          }
          ListProductCoupons{
            coupon_display_type
            coupon_value
            created_at
            end_time
            invisible_id
            member_max_num_of_use
            min_amount
            name
            start_time
            updated_at
          }
        }
      `,
      variables: {
        name: 'ProductCouponListVo',
      }
    }).then(data => {
      commit('set', ['productCouponsUiMeta', data.GetUiMeta])
      commit('setProductCoupons', data.ListProductCoupons)
      return true
    })
  },
  getProductCoupon({ commit, state }, id) {
    return gqlApi.query({
      query: `
        query($id: String!){
          GetProductCoupon(id: $id){
            coupon_type
            coupon_value
            created_at
            end_time
            id
            member_max_num_of_use
            min_amount
            name
            start_time
            updated_at
          }
        }
      `,
      variables: {
        id,
      },
    }).then(resp => {
      commit('setProductCoupon', resp.GetProductCoupon)
      return true
    })
  },
  updateProductCoupon(_, productCoupon) {
    return gqlApi.query({
      query: `    
        mutation($input: ProductCouponUpdateVo){
          UpdateProductCoupon(input: $input){
            id
          }
        }
      `,
      variables: {
        input: productCoupon,
      },
    }).then(() => {
      return true
    })
  },
  addProductCoupon(_, productCoupon) {
    return gqlApi.query({
      query: `    
        mutation($input: ProductCouponAddVo){
          AddProductCoupon(input: $input){
            id
          }
        }
      `,
      variables: {
        input: productCoupon,
      },
    }).then(() => {
      return true
    })
  },
  deleteProductCoupon(_, id) {
    return gqlApi.query({
      query: `    
        mutation($id: String){
          DeleteProductCoupon(id: $id)
        }
      `,
      variables: {  
        id: id,
      },
    }).then(() => {
      return true
    })
  },

  listProductOrders({ commit, }, { status, id, memberId, }) {
    return gqlApi.query({
      query: `
        query($name: String!, $status: [String], $id: String, $memberId: String){
          GetUiMeta(name: $name, filterInvisible: true){
            key
            label
          }
          ListProductOrders(status: $status, id: $id, memberId: $memberId){
            created_at
            i18n_status
            i18n_pickup_type
            id
            order_no
            grand_total
            member_id
            member_name
            updated_at
          }
        }
      `,
      variables: {
        name: 'ProductOrderListVo',
        status,
        id,
        memberId,
      }
    }).then(data => {
      commit('set', ['productOrdersUiMeta', data.GetUiMeta])
      commit('setProductOrders', data.ListProductOrders)
      return true
    })
  },
  getProductOrder({ commit, }, id) {
    return gqlApi.query({
      query: `
        query($name: String!, $id: String!){
          GetUiMeta(name: $name, filterInvisible: true){
            key
            label
          }
          GetProductOrder(id: $id){
            created_at
            discount_total
            grand_total
            id
            member_id
            order_no
            pickup_type
            receiver_address
            receiver_cellphone
            receiver_county
            receiver_district
            receiver_full_name
            receiver_home_phone
            receiver_note
            receiver_postal_code
            seller_note
            shipping_fee
            shipping_id
            sub_total
            status,
            payment_status,
            product_order_items,
            updated_at
            coupon_name
          }
        }
      `,
      variables: {
        id,
        name: 'ProductOrderItemListVo',
      },
    }).then(resp => {
      commit('setProductOrder', resp.GetProductOrder)
      commit('set', ['productOrderItemsUiMeta', resp.GetUiMeta])
      return true
    })
  },
  updateProductOrder(_, productOrder) {
    return gqlApi.query({
      query: `
        mutation($input: ProductOrderUpdateVo){
          UpdateProductOrder(input: $input){
            id
          }
        }
      `,
      variables: {
        input: productOrder,
      },
    }).then(() => {
      return true
    })
  },

}

// mutations
const mutations = {
  set (state, [variable, value]) {
    state[variable] = value
  },
  setProductCategories (state, productCategories) {
    state.productCategories = productCategories
  },
  setProductCategory (state, productCategory) {
    state.productCategory = productCategory
  },
  setProducts (state, products) {
    state.products = products
  },
  setProduct(state, product) {
    state.product = product
  },
  setProductShippings (state, productShippings) {
    state.productShippings = productShippings
  },
  setProductShipping(state, productShipping) {
    state.productShipping = productShipping
  },
  setProductCoupons (state, productCoupons) {
    state.productCoupons = productCoupons
  },
  setProductCoupon(state, productCoupon) {
    state.productCoupon = productCoupon
  },
  setProductOrders (state, productOrders) {
    state.productOrders = productOrders
  },
  setProductOrder(state, productOrder) {
    state.productOrder = productOrder
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}